'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M4.667 23A3.667 3.667 0 0 1 1 19.333V9.25a3.667 3.667 0 0 1 3.667-3.666h12.546l1.602-4.008a.917.917 0 1 1 1.703.681l-1.33 3.327h.145A3.667 3.667 0 0 1 23 9.25v10.083A3.667 3.667 0 0 1 19.333 23zM17.854 7.417h1.48c1.012 0 1.832.82 1.832 1.833v10.083c0 1.013-.82 1.834-1.833 1.834H4.667a1.833 1.833 0 0 1-1.834-1.834V9.25c0-1.012.821-1.833 1.834-1.833h13.187M15.5 18a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" clipRule="evenodd" /></svg>;
const IconRadio = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconRadio;